import { SxProps, Theme } from '@mui/material';

export const imageCategorySX: SxProps<Theme> = {
	width: '100%',
	objectFit: 'cover',
	maxWidth: {
		xs: '114px',
		sm: '194px',
	},
	height: {
		xs: '133px',
		sm: '255px',
	},
};
